export default function ConvertSection() {
  return (
    <section className="bg-fog py-24 px-5 lg:px-16" id="book">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
        {/* Private events panel */}
        <ConvertPanel variant="dark">
          <Eyebrow color="gold">For Private Events</Eyebrow>
          <h3 className="font-syne font-extrabold text-white leading-tight tracking-tight text-3xl">
            Ready to Transform Your Space?
          </h3>
          <p className="text-white/50 font-light text-sm leading-relaxed mt-4 max-w-sm">
            Tell us about your event and get a custom quote within 48 hours. We bring the vision — you show up and celebrate.
          </p>
          <ul className="mt-6 space-y-2.5">
            {[
              "Custom packages for any budget",
              "Available across NYC & New Jersey",
            ].map((item) => (
              <li key={item} className="flex items-center gap-3 text-sm text-white/40">
                <span className="w-1.5 h-1.5 rounded-full bg-gold/60 shrink-0" />
                {item}
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-5 mt-8 flex-wrap">
            <a
              href="#contact"
              className="bg-violet hover:bg-violet-deep text-white font-syne font-bold text-[10px] tracking-[0.18em] uppercase px-[26px] py-3.5 rounded-sm transition-colors"
            >
              Request a Quote
            </a>
            <a href="#services" className="text-xs font-medium text-white/30 underline underline-offset-2 hover:text-white/60 transition-colors">
              View pricing →
            </a>
          </div>
        </ConvertPanel>

        {/* Government panel */}
        <ConvertPanel variant="light">
          <Eyebrow color="violet">For Corporate, Government & Institutions</Eyebrow>
          <h3 className="font-syne font-extrabold text-ink leading-tight tracking-tight text-3xl">
            Add Us to Your Approved Vendor List
          </h3>
          <p className="text-ink-55 font-light text-sm leading-relaxed mt-4 max-w-sm">
            We're vendor-ready with all documentation needed for government procurement and institutional compliance.
          </p>
          <ul className="mt-6 space-y-2.5">
            {[
              "SAM.gov registered & active",
              "Woman & Minority-Owned Business",
              "Full insurance documentation available",
              "NAICS codes: 541410 & 323111",
            ].map((item) => (
              <li key={item} className="flex items-center gap-3 text-sm text-ink-55">
                <span className="w-1.5 h-1.5 rounded-full bg-violet/60 shrink-0" />
                {item}
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-5 mt-8 flex-wrap">
            <a
              href="/capability_statement.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-violet hover:bg-violet-deep text-white font-syne font-bold text-[10px] tracking-[0.18em] uppercase px-[26px] py-3.5 rounded-sm transition-colors"
            >
              Download Capability Statement
            </a>
            <a href="#contact" className="text-xs font-medium text-ink-35 underline underline-offset-2 hover:text-violet transition-colors">
              Submit vendor inquiry
            </a>
          </div>
        </ConvertPanel>
      </div>
    </section>
  );
}

function ConvertPanel({
  variant,
  children,
}: {
  variant: "dark" | "light";
  children: React.ReactNode;
}) {
  const base = "relative rounded-2xl px-12 py-14 overflow-hidden";
  const styles =
    variant === "dark"
      ? `${base} bg-ink-2 border border-violet/25`
      : `${base} bg-white border border-ink-10`;

  return (
    <div className={styles}>
      <div
        className="absolute pointer-events-none rounded-full"
        aria-hidden="true"
        style={
          variant === "dark"
            ? { top: -80, right: -80, width: 280, height: 280, background: "radial-gradient(circle, rgba(107,53,168,0.18) 0%, transparent 65%)" }
            : { bottom: -60, left: -60, width: 240, height: 240, background: "radial-gradient(circle, rgba(107,53,168,0.06) 0%, transparent 70%)" }
        }
      />
      {children}
    </div>
  );
}

function Eyebrow({ children, color }: { children: React.ReactNode; color: "gold" | "violet" }) {
  const textColor = color === "gold" ? "text-gold" : "text-violet";
  const lineColor = color === "gold" ? "bg-gold" : "bg-violet";
  return (
    <p className={`flex items-center gap-2.5 font-syne text-[10px] font-bold tracking-[0.22em] uppercase mb-5 ${textColor}`}>
      <span className={`w-5 h-px shrink-0 ${lineColor}`} />
      {children}
    </p>
  );
}
